export interface TopicLabelSource {
  topicRaw?: string;
  topicNormalized: string;
}

function slugKey(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function resolveLaunchTopicLabel(launchingLabel: string, content: TopicLabelSource): string {
  const launchLabel = launchingLabel.trim();
  const normalized = content.topicNormalized.trim();
  if (launchLabel && slugKey(launchLabel) !== slugKey(normalized)) return launchLabel;
  return content.topicRaw?.trim() || normalized;
}
